import './page.scss';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

const blogItems = [
  {
    id: 1,
    img: '/Car-selling.webp',
    title: 'Buying and selling used cars in Nigeria in 2025: wetin dey happen?',
    text: 'In Naija today, 2025 style, the used car business no be joke. As economy dey shake small-small and import wahala still dey, people just dey look for',
    link: '/',
  },
  {
    id: 2,
    img: '/jobs-nigeria.webp',
    title: 'Is it that difficult to find a suitable job in Nigeria?',
    text: 'In recent years, the Nigerian job market has faced increasing scrutiny from graduates, job seekers, and economic analysts alike.',
    link: '/',
  },
  {
    id: 3,
    img: '/how-to-sell-used-goods.webp',
    title: 'How to sell used items in Nigeria without wahala',
    text: 'Selling secondhand items online can bring cash, clear space, or help someone get a good deal. But let’s be honest - nigerian buyers sabi haggle!',
    link: '/selling-used-goods',
  },
];

const Blog = () => {
  const { id } = useParams();

  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) el.scrollIntoView({ behavior: 'auto' });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>Naijads.ng Blog – News & Updates</title>
        <meta
          name="description"
          content="Stay updated with fresh news from Naijads.ng – new features, community growth, marketplace trends across Nigeria."
        />
        <link rel="canonical" href="https://naijads.ng/blog" />
        <meta property="og:title" content="Our blog - News & Updates" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Blog',
            name: 'Naijads.ng Blog',
            url: 'https://naijads.ng/blog',
            publisher: {
              '@type': 'Organization',
              name: 'Naijads.ng',
              logo: {
                '@type': 'ImageObject',
                url: 'https://naijads.ng/assets/Tayo.svg',
              },
            },
            blogPost: blogItems.map((item) => ({
              '@type': 'BlogPosting',
              headline: item.title,
              url: `https://naijads.ng${item.link}`,
              image: `https://naijads.ng${item.img}`,
              description: item.text,
            })),
          })}
        </script>
      </Helmet>

      <div className="info-page">
        <div className="info-block-main">
          <h1>Our blog</h1>
          <p>Stay updated with latest news, features, and marketplace trends from the heart of Naija.</p>
        </div>

        <div className="blog-grid">
          {blogItems.map(({ id, img, title, text, link }) => (
            <div key={id} className="blog-card">
             <img
  src={img}
  alt={title}
  width="300"
  height="250"
  style={{ borderRadius: '8px', objectFit: 'cover', width: '100%', height: 'auto' }}
/>

              <h3>{title}</h3>
              <p style={{ lineHeight: '1.5' }}>{text}</p>
              <Link to={link} className="read-more">Read more...</Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Blog;
